import { defineComponent as _defineComponent } from 'vue'
import { ISurvey } from "@/domain/entities/survey";
import { PropType, computed, ref } from "vue";
import BaseSelect from "../shared/inputs/base/BaseSelect.vue";
import InlineSvg from "vue-inline-svg";
import BaseTextarea from "../shared/inputs/base/BaseTextarea.vue";

type QuestionCodeType = (typeof QuestionCode)[keyof typeof QuestionCode];


const __default__ = {
  name: "ServiceEvaluationQuestions",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  lineSurvey: {
    type: Object as PropType<ISurvey>,
  },
},
  emits: ["onChangeSelectLine", "onReceivedEmptyTargetLines", "onChangeAnswer"],
  setup(__props, { expose: __expose, emit: __emit }) {



const emit = __emit;

const QuestionCode = {
  RADIO: "radio",
  OPTION: "option",
  OPTION_MULTI: "optionMulti",
  TEXT: "text",
} as const;

const answerKeyByQuestionType: Record<QuestionCodeType, string> = {
  radio: "selected",
  option: "selected",
  optionMulti: "selected",
  text: "inputValue",
};

const moodIconList = [
  {
    src: require("@/assets/icons/moods/mood-bad.svg"),
    score: 1,
    detail: "별로에요",
  },
  {
    src: require("@/assets/icons/moods/mood-soso.svg"),
    score: 2,
    detail: "그저그래요",
  },
  {
    src: require("@/assets/icons/moods/mood-normal.svg"),
    score: 3,
    detail: "보통이에요",
  },
  {
    src: require("@/assets/icons/moods/mood-good.svg"),
    score: 4,
    detail: "좋아요",
  },
  {
    src: require("@/assets/icons/moods/mood-nice.svg"),
    score: 5,
    detail: "최고에요",
  },
];

const userAnswers = ref<Map<number, Map<string, string | string[]>>>(new Map());
const selectedTurnId = ref("");
const selectedScore = ref(0);
const selectedReview = ref<string[]>([]);
const opinion = ref("");

// 필수 입력값이 모두 작성되었는지 여부
const isValid = computed(
  () =>
    !!selectedTurnId.value.length &&
    !!selectedScore.value &&
    !!selectedReview.value.length
);

const onChangeSelectLine = (uid: string) => {
  selectedTurnId.value = uid;
};

const onChangeAnswer = (type: QuestionCodeType, value: any, order: number) => {
  const map = new Map<string, string>();
  const key = answerKeyByQuestionType[type];
  map.set(key, value);
  userAnswers.value.set(order - 1, map);
};

const isQuestionCodeType = (value: string): value is QuestionCodeType => {
  return Object.values(QuestionCode).includes(value as QuestionCodeType);
};

const onClickMoodIcon = (type: string, uid: string, order: number) => {
  if (!isQuestionCodeType(type)) return;

  selectedScore.value = parseInt(uid);
  onChangeAnswer(type, uid, order);
};

const isSelectedReview = (review: string) => {
  return selectedReview.value.includes(review);
};

const onClickReview = (type: string, review: string, order: number) => {
  if (!isQuestionCodeType(type)) return;

  if (isSelectedReview(review)) {
    selectedReview.value = selectedReview.value.filter(
      (reviewItem: string) => reviewItem !== review
    );
  } else {
    selectedReview.value.push(review);
  }

  onChangeAnswer(type, selectedReview.value, order);
};

const onInputTextarea = (type: string, text: string, order: number) => {
  if (!isQuestionCodeType(type)) return;

  opinion.value = text;
  onChangeAnswer(type, text, order);
};

const emitOnReceivedEmptyTargetLines = () => {
  emit("onReceivedEmptyTargetLines");
};

__expose({ selectedTurnId, userAnswers, isValid });

const __returned__ = { emit, QuestionCode, answerKeyByQuestionType, moodIconList, userAnswers, selectedTurnId, selectedScore, selectedReview, opinion, isValid, onChangeSelectLine, onChangeAnswer, isQuestionCodeType, onClickMoodIcon, isSelectedReview, onClickReview, onInputTextarea, emitOnReceivedEmptyTargetLines, BaseSelect, get InlineSvg() { return InlineSvg }, BaseTextarea }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})